import React, { useState } from 'react';
import { GraduationCap, ChevronDown, BookOpen } from 'lucide-react';

// Expert litigator's model answer shown after each closed stage
export const ModelAnswer = ({ m, stage }) => {
  const [open, setOpen] = useState(true);
  return (
    <div data-testid={`trial-model-answer-${stage}`} className="rounded-xl border border-emerald-500/30 bg-emerald-500/5 p-3">
      <button data-testid={`trial-model-answer-toggle-${stage}`} onClick={() => setOpen(!open)} className="flex w-full items-center gap-2 text-left text-xs font-semibold text-emerald-200">
        <GraduationCap className="h-4 w-4" />Así lo habría argumentado un litigante experto
        <ChevronDown className={`ml-auto h-4 w-4 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="mt-2 space-y-2">
          <p className="whitespace-pre-line text-xs text-slate-200">{m.texto}</p>
          {m.normas?.length > 0 && (
            <ul data-testid={`trial-model-norms-${stage}`} className="space-y-0.5">
              {m.normas.map((n, i) => <li key={i} className="flex gap-1.5 text-[11px] text-sky-200"><BookOpen className="mt-0.5 h-3 w-3 shrink-0" />{n}</li>)}
            </ul>
          )}
          {m.claves?.length > 0 && <ul className="list-disc pl-4 text-[11px] text-slate-400">{m.claves.map((c, i) => <li key={i}>{c}</li>)}</ul>}
          <p className="text-[10px] text-slate-500">Referencia de práctica generada por IA · verifica las normas antes de usarlas en un escrito real.</p>
        </div>
      )}
    </div>
  );
};
